import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import times from 'lodash/times';
import { Page } from './page';
import { Separator } from './separator';
import { PagePattern } from './pagepattern';
import { PreviewBuilder } from '../componentsbuilder';
export class Document extends React.PureComponent {
    contentRef;
    patternRef;
    observer;
    constructor(props) {
        super(props);
        this.state = {
            emptySpaceHeight: 0,
            pageCount: 1,
        };
        this.contentRef = React.createRef();
        this.patternRef = React.createRef();
        this.observer = new ResizeObserver((entries) => {
            entries.forEach(() => {
                const pageCount = Math.ceil(this.contentRef.current.offsetHeight / this.patternRef.current.offsetHeight);
                // Kdyz velikost obsahu nevychazi presne na stranky
                if (this.contentRef.current.offsetHeight % this.patternRef.current.offsetHeight !== 0) {
                    this.setState({
                        emptySpaceHeight: this.patternRef.current.offsetHeight * pageCount -
                            this.contentRef.current.offsetHeight,
                        pageCount,
                    });
                }
                else {
                    this.setState({
                        emptySpaceHeight: 0,
                        pageCount,
                    });
                }
            });
        });
    }
    componentDidMount() {
        this.contentRef.current && this.observer.observe(this.contentRef.current);
    }
    componentWillUnmount() {
        this.observer.disconnect();
    }
    render() {
        return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
            @page {
              size: ${this.props.size} ${this.props.orientation};
              margin: 0mm
            }
          ` }), _jsxs("div", { id: 'rpx-image-capture' // id slouzi jako selector na strane sluzby pro generovani screenshotu
                    , className: 'rpx-document', ref: this.props.reference, style: {
                        // @ts-ignore
                        '--RPX_PAGE_MARGIN': this.props.margins ? '13mm' : '0mm',
                    }, children: [_jsx(PagePattern, { reference: this.patternRef, size: this.props.size, orientation: this.props.orientation }), _jsx("div", { className: 'rpx-document--body', ref: this.contentRef, children: this.props.pageTemplates.map((page, index) => (_jsx(Page, { number: index + 1, size: this.props.size, orientation: this.props.orientation, areas: page.areas, columns: page.columns, rows: page.rows, margins: this.props.margins, children: _jsx(PreviewBuilder, { pageNum: index }) }, index))) }), _jsx("div", { className: 'rpx-document--separators', children: times(this.state.pageCount - 1, (i) => (_jsx(Separator, { size: this.props.size, orientation: this.props.orientation }, i))) }), _jsx("div", { className: 'rpx-document--emptySpace', style: { height: this.state.emptySpaceHeight } })] })] }));
    }
}
//# sourceMappingURL=document.js.map